import { motion } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { Card } from "../Card";

type Props = {
  children: React.ReactNode;
  className?: string;
  theme?: "none" | "default" | "border";
} & React.HTMLAttributes<HTMLDivElement>;

export function MainWindow({ children, className, theme, ...props }: Props) {
  return (
    <Card
      theme={theme}
      className={twMerge("w-0 shrink grow transition-[flex-grow]", className)}
      {...props}
    >
      {children}
    </Card>
  );
}

// Used as the content container for pages - mainly for providing a smooth
// transition when navigating between pages.
// TODO: maybe rename to something more generic as we might just use it for all "containers" that need to fade.
export function PageContent({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <motion.main
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {children}
    </motion.main>
  );
}
